import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'lms-document-create',
  templateUrl: './document-create.component.html',
  styleUrls: ['./document-create.component.css']
})
export class DocumentCreateComponent implements OnInit {
  public clientId: any;

  constructor(public location: Location, public router: Router) {}

  ngOnInit(): void {}

  onSave(document): void {
    this.router.navigate(['/documents', document.id], { replaceUrl: true });
  }

  cancel(): void {
    this.location.back();
  }
}
